import StateType from './state.type';

export default {
  loading: false,
  invoices: [],
  total: 0,
} as StateType;
